import React, { useEffect, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { ScrollReveal } from './ui/ScrollReveal';
export function HeroSection() {
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      // Slow zoom effect: 1.0 to 1.1 over 1000px scroll
      const newScale = 1 + scrollY * 0.0001;
      if (newScale <= 1.1) {
        setScale(newScale);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section className="relative h-screen w-full overflow-hidden bg-black" data-id="element-121">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full overflow-hidden" data-id="element-122">
        <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover transition-transform duration-100 ease-out" style={{
        transform: `scale(${scale})`
      }} data-id="element-123">
          <source src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/GLE%20Website%20Video.mp4" type="video/mp4" data-id="element-124" />
        </video>
      </div>

      {/* Dark Overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/30" data-id="element-125" />

      {/* Content Container */}
      <div className="absolute inset-0 flex flex-col justify-center md:justify-end pb-12 md:pb-32 pt-24 md:pt-0 px-6 md:px-12 lg:px-24" data-id="element-126">
        <div className="max-w-5xl relative mt-auto md:mt-0" data-id="element-127">
          {/* Decorative 'G' - Absolute positioned behind text */}
          <div className="hidden md:block absolute -top-52 -left-24 text-[350px] font-serif font-bold text-gold opacity-25 select-none pointer-events-none" style={{
          textShadow: '0 0 80px rgba(212, 175, 55, 0.4), 0 0 160px rgba(212, 175, 55, 0.2)'
        }} data-id="element-128">
            G
          </div>

          <ScrollReveal delay={0.2} data-id="element-129">
            <h2 className="text-gold text-lg md:text-2xl font-light tracking-widest uppercase mb-4" data-id="element-130">
              Welcome to Glenlofty Estate
            </h2>
          </ScrollReveal>

          <ScrollReveal delay={0.4} data-id="element-131">
            <h1 className="text-5xl md:text-7xl lg:text-[120px] leading-[0.9] text-white mb-8 tracking-tight font-[500]" data-id="element-132">
              Ancient Soils,
              <br data-id="element-133" />
              <span className="text-gray-200" data-id="element-134">Pristine Wines</span>
            </h1>
          </ScrollReveal>

          <ScrollReveal delay={0.6} data-id="element-135">
            <p className="text-lg md:text-2xl text-gray-300 max-w-2xl mb-12 font-light leading-relaxed" data-id="element-136">
              Discover the soul of the Pyrenees in every bottle. From our
              rugged, ancient soils, we craft wines of exceptional elegance,
              intensity, and character.
            </p>
          </ScrollReveal>

          <ScrollReveal delay={0.8} data-id="element-137">
            <Button variant="primary" size="lg" data-id="element-138">
              Explore Our Wines
            </Button>
          </ScrollReveal>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-pulse-slow" data-id="element-139">
        <ChevronDownIcon className="w-10 h-10 text-gold opacity-80" data-id="element-140" />
      </div>
    </section>;
}